/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menu_Platform_AdminInputs */



/**
* | output |
* | --- |
* | "Platform admin" |
*
* @param {Menu_Platform_AdminInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const menu_platform_admin = /** @type {((inputs?: Menu_Platform_AdminInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menu_Platform_AdminInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Администратор платформы")
	return /** @type {LocalizedString} */ ("Platform admin")
});